import { useEffect, useState } from "react";

const _MONTHS_FR = [
  "janv.", "févr.", "mars", "avr.", "mai", "juin",
  "juil.", "août", "sept.", "oct.", "nov.", "déc.",
];

export default function AvailabilityDeadline({ deadline, locked }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (locked) return;
    const target = deadline ? new Date(deadline).getTime() : 0;
    const remaining = target - Date.now();
    const interval = remaining < 3_600_000 ? 1000 : 60_000;
    const t = setInterval(() => setNow(Date.now()), interval);
    return () => clearInterval(t);
  }, [locked, deadline, now]);
  const target = deadline ? new Date(deadline).getTime() : null;
  if (!target) return null;

  const diff = target - now;
  const d = new Date(deadline);
  const dateLabel = `${d.getDate()} ${_MONTHS_FR[d.getMonth()]} ${d.getFullYear()} · ${d
    .getHours()
    .toString()
    .padStart(2, "0")}h${d.getMinutes().toString().padStart(2, "0")}`;

  if (locked || diff <= 0) {
    return (
      <span
        data-testid="avail-deadline-badge"
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-rose-500/15 border border-rose-500/40 text-rose-300 text-[10px] font-mono-stat uppercase tracking-widest"
      >
        Verrouillé · {dateLabel}
      </span>
    );
  }
  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86_400);
  const hours = Math.floor((totalSec % 86_400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  let label;
  if (days >= 1) {
    label = `J-${days + (hours > 0 ? 1 : 0)} avant verrouillage`;
  } else if (hours >= 1) {
    label = `${hours}h ${minutes.toString().padStart(2, "0")}m`;
  } else {
    label = `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }
  const urgent = totalSec < 3600;
  return (
    <span
      data-testid="avail-deadline-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[10px] font-mono-stat uppercase tracking-widest ${
        urgent
          ? "bg-orange-500/15 border-orange-500/40 text-orange-300 animate-pulse"
          : "bg-[#E5B85C]/15 border-[#E5B85C]/40 text-[#E5B85C]"
      }`}
    >
      Deadline {dateLabel} · <b>{label}</b>
    </span>
  );
}
